import gql from "graphql-tag";
import { QR_FIELDS } from "@/apollo/queries/qr";

// Cada documento se llama igual que su campo raíz: exMut lee el resultado con ese nombre.
export const QR_SAVE = gql`
  mutation qrAdminSave($input: QrAdminSaveInput!) {
    qrAdminSave(input: $input) {
      ${QR_FIELDS}
    }
  }
`;

export const QR_STATUS = gql`
  mutation qrAdminStatus($id: ID!, $version: Int!, $status: String!) {
    qrAdminStatus(id: $id, version: $version, status: $status) {
      ${QR_FIELDS}
    }
  }
`;

export const QR_CREATE_FOLDER = gql`
  mutation qrAdminCreateFolder($name: String!) {
    qrAdminCreateFolder(name: $name) {
      id
      name
      version
    }
  }
`;

export const QR_RENAME_FOLDER = gql`
  mutation qrAdminRenameFolder($id: ID!, $version: Int!, $name: String!) {
    qrAdminRenameFolder(id: $id, version: $version, name: $name) {
      id
      name
      version
    }
  }
`;

export const QR_MOVE = gql`
  mutation qrAdminMove($id: ID!, $version: Int!, $folderId: String!) {
    qrAdminMove(id: $id, version: $version, folderId: $folderId) {
      ${QR_FIELDS}
    }
  }
`;

export const QR_ARCHIVE = gql`
  mutation qrAdminArchive($id: ID!, $version: Int!, $archived: Boolean!) {
    qrAdminArchive(id: $id, version: $version, archived: $archived) {
      ${QR_FIELDS}
    }
  }
`;
